// src/Tagline.js
import React from 'react';
import './Tagline.css';

const Tagline = () => {
  return (
    <div className="tagline">
      <h1>Precision in fibrosis</h1>
    </div>
  );
};

export default Tagline;
